define('models/note/note',[
    'underscore', 'backbone', 'moment', 'mustache', 'utils',
    // src
    'services/api',
    // parent
    'src/file-upload-model',
], function(
    _, Backbone, moment, Mustache, U,
    API,
    // parent
    FileUploadModel
) {

    var MNote = FileUploadModel.extend({
        idAttribute: '_id',
        files: ['attachment'],
        blacklist: ['date'],
        urlRoot: function() {
            return API.url(Mustache.render("groups/{{{group}}}/users/{{{user}}}/notes/", {
                user: this.user,
                group: this.group
            }));
        },
        defaults: {
            text: "",
        },

        computeds: {
            attachmentUrl: {
                deps: ['attachment'],
                get: function(attachment) {
                    return attachment && attachment.url;
                },
            },
            attachmentName: {
                deps: ['attachment'],
                get: function(attachment) {
                    return attachment && attachment.name;
                },
            },
        },

        setUser: function(user) {
            this.user = user;
        },

        setGroup: function(group) {
            this.group = group;
        },

        setTimeStamp: function(momentTime, options) {
            return this.set('date', API.formatTimeStamp((momentTime || moment()).utc()), options);
        },
        getTimeStampObject: function() {
            return API.formatTimeStamp(this.get('date'));
        },
        setAttachment: function(files) {
            this.set('attachment', files);
        },
        getAttachments: function() {
            return this.get("attachment");
        },
        // This function is to format the attachment correctly - notes use attachment in singular while messages use attachments in plural 
        addAttachment: function(file) {
            return { attachment: file }
        },
    });

    return MNote;
});

